import { getSidePanelMaxSize } from '../side-panel/functions';
import { DEFAULT_CUSTOM_PANEL_WIDTH } from './constants';
export * from './functions.custom';
/**
 * Returns whether the custom panel is enabled based on Redux state.
 * The feature is disabled by default and can be enabled dynamically via console.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {boolean} Whether the custom panel is enabled.
 */
export function isCustomPanelEnabled(state) {
    return Boolean(state['features/custom-panel']?.enabled);
}
/**
 * Returns whether the custom panel is currently open.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {boolean} Whether the custom panel is open.
 */
export function getCustomPanelOpen(state) {
    return Boolean(state['features/custom-panel']?.isOpen);
}
/**
 * Returns the current configured width of the custom panel from Redux state.
 * Falls back to the default width if no dynamic width is set.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {number} The panel width in pixels.
 */
export function getCustomPanelConfiguredWidth(state) {
    return state['features/custom-panel']?.width?.current ?? DEFAULT_CUSTOM_PANEL_WIDTH;
}
/**
 * Returns the current panel width (0 if closed or disabled).
 * With the unified side panel, custom panel no longer reserves its own flex width.
 *
 * @param {IReduxState} _state - The Redux state.
 * @returns {number} Always 0.
 */
export function getCustomPanelWidth(_state) {
    return 0;
}
/**
 * Calculates the maximum width available for the custom panel based on the
 * current window size and other open UI panels.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {number} The maximum width in pixels. Returns 0 if no space is available.
 */
export function getCustomPanelMaxSize(state) {
    return getSidePanelMaxSize(state);
}
